import script from "./AdminCards.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCards.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fea6b3e"]])

export default __exports__